// extracted by mini-css-extract-plugin
module.exports = {"title":"ExpirationDHero_title___FS5N","content":"ExpirationDHero_content__dc7wU"};